import { Feature } from '../feature';

export const FEATURES_KEY = 'features';

export function persistFeatureResult(feature: Feature, result: boolean) {
  const allResults = readAllFeaturesResults();
  allResults[feature.name] = result;

  localStorage.setItem(FEATURES_KEY, JSON.stringify(allResults));
}

export function getPersistedFeatureResult(
  feature: Feature,
): boolean | undefined {
  const allResults = readAllFeaturesResults();

  if (feature.name in allResults) {
    return allResults[feature.name];
  }

  return undefined;
}

function readAllFeaturesResults(): { [key: string]: boolean } {
  let allFeatureResults = {};

  try {
    const persistedResults = localStorage.getItem(FEATURES_KEY);

    if (persistedResults) {
      allFeatureResults = JSON.parse(persistedResults);
    }
  } catch (err) {
    console.error(`feature results are corrupted`);
  }

  return allFeatureResults;
}
